export default __webpack_public_path__ + "static/media/SndLowerZGoAcross.60d82f93.mp3";